import { useTransformStore } from "@/store/transformsStore"
import { useEffect } from "react"
import dynamic from 'next/dynamic'
import { Link } from "@/navigation"
import { useTranslations } from "next-intl"
import { ArrowRight } from "lucide-react"

// Dynamically import the SuccessCarousel component
const DynamicSuccessCarousel = dynamic(
    () => import("@/components/pages/home/SuccessStories/SuccessCarousel"),
    {
        loading: () => (
            <div className="w-full min-h-[600px] animate-pulse bg-gray-100 rounded-2xl" />
        ),
        // Force client-side rendering to avoid RSC/lazy chunk mismatch during SSR
        ssr: false
    }
);

const SuccessStories = () => {
    const getAllTransforms = useTransformStore(state => state.getAllTransforms)
    const t = useTranslations("Home.success-stories")

    useEffect(() => {
        getAllTransforms()
    }, [])

    return (
        <div className="w-full relative overflow-visible">
            {/* Background gradient */}
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/5 to-transparent rounded-3xl" />
            
            {/* Content */}
            <div className="relative">
                {/* Extended container for carousel */}
                <div className="mx-[-2rem] md:mx-[-4rem] lg:mx-[-6rem]">
                    <DynamicSuccessCarousel />
                </div>
                
                {/* Show More Button */}
                <div className="flex justify-center mt-12">
                    <Link 
                        href="/transforms"
                        className="group relative inline-flex items-center gap-2 px-8 py-4 
                                 bg-gradient-to-r from-primary to-secondary rounded-full
                                 text-white font-semibold text-lg
                                 shadow-[0_0_20px_rgba(0,91,150,0.3)]
                                 transition-all duration-300
                                 hover:shadow-[0_0_30px_rgba(0,91,150,0.5)]
                                 hover:scale-105"
                    >
                        <span>{t("showMore")}</span>
                        <ArrowRight className="w-5 h-5 transition-transform duration-300 
                                             group-hover:translate-x-1" />
                        
                        {/* Animated background effect */}
                        <div className="absolute inset-0 rounded-full bg-white/20 blur-xl
                                      opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default SuccessStories